module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.data,
    attrs: {
      "id": "devyn",
      "width": "160px",
      "height": "454px",
      "viewBox": "0 0 160 454"
    }
  }, [_c('g', {
    attrs: {
      "id": "devyn_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "devyn_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "d": "M33.9798252,246.640347 C33.9585384,249.529967 32.0923815,250.353867 30.0690461,253.763604 C27.7083139,257.741923 27.9874442,264.87022 25.3713332,270.898093 C26.1279287,272.282695 30.638675,269.670745 31.5562525,267.248831 C32.4738301,264.826918 33.1695244,262.858883 33.4880375,262.246173 C33.8065506,261.633463 34.6000928,261.675538 34.8428854,262.254062 C35.0856781,262.832587 35.708494,283.868259 36.2070715,284.899084 C36.705649,285.929909 39.4642688,285.966549 39.9397039,284.899084 C40.415139,283.831619 40.3505838,267.187999 40.5834292,266.742535 C40.8162747,266.297071 41.4226473,266.511476 41.6786352,266.742535 C41.9346231,266.973594 41.4930896,284.752875 41.9049845,285.414497 C42.3168794,286.076118 45.1658359,285.961465 45.4739958,285.414497 C45.7821557,284.867528 45.8879207,267.144872 46.1977047,266.742535 C46.5074886,266.340198 47.1351766,266.385252 47.3919765,266.742535 C47.6487764,267.099818 46.948007,284.165936 47.3919765,284.899084 C47.835946,285.632232 50.5982199,285.643803 50.8523807,284.899084 C51.1065416,284.154366 51.6704864,266.991826 51.9380455,266.742535 C52.2056046,266.493244 52.5655305,266.51656 52.8205034,266.742535 C53.0754763,266.96851 53.3452684,279.787032 53.7859898,280.483716 C54.2267113,281.1804 56.3172453,281.345016 56.6254052,280.483716 C56.9335651,279.622416 55.460025,248.374477 55.5010552,246.640347 C55.6377913,240.861246 52.0219824,234.82495 44.7674994,234.82495 C37.5130164,234.82495 34.0255368,240.435129 33.9798252,246.640347 Z",
      "id": "devyn_right_hand",
      "fill": "#DBBFAF",
      "transform": "translate(41.019575, 260.346842) rotate(5.000000) translate(-41.019575, -260.346842) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.7020582,192.367693 C56.6223671,192.885653 61.0018363,198.104901 60.4838764,204.02521 L56.7324788,246.903881 C56.2145189,252.82419 50.9952708,257.203659 45.0749618,256.685699 C39.1546529,256.167739 34.7751837,250.948491 35.2931436,245.028182 L39.0445412,202.149511 C39.5625011,196.229202 44.7817492,191.849733 50.7020582,192.367693 Z",
      "id": "devyn_right_arm_bottom",
      "fill": "#DBBFAF"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.2670039,117.33002 C63.1873129,117.84798 67.5667821,123.067228 67.0488222,128.987537 L60.4838764,204.02521 C59.9659165,209.945519 54.7466684,214.324988 48.8263594,213.807028 C42.9060504,213.289068 38.5265812,208.06982 39.0445412,202.149511 L45.6094869,127.111838 C46.1274468,121.191529 51.346695,116.81206 57.2670039,117.33002 Z",
      "id": "devyn_right_arm_top",
      "fill": "#DBBFAF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.7310206,117.283127 C64.1314068,117.930577 69.6057433,124.454637 68.9582934,131.855023 L67.7859816,145.254608 L40.9868125,142.909984 L42.1591243,129.5104 C42.8065742,122.110014 49.3306344,116.635677 56.7310206,117.283127 Z",
      "id": "devyn_right_shoulder",
      "fill": "#4A4A4A"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.8632812,391 C40.5922852,391 44.6368001,391 45.9968262,391 C48.1517281,428.014677 56.9238281,424.814941 64.1335449,428.836304 C63.4503291,430.97193 60.6508789,434.859375 56.9238281,434.859375 C41.8749055,430.089586 34.1880565,415.469795 33.8632812,391 Z",
      "id": "devyn_right_shoe_6",
      "fill": "#D764B1",
      "transform": "translate(48.998413, 412.929688) scale(-1, 1) translate(-48.998413, -412.929688) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.4707171,391 L19.4707171,391 L19.6591937,445.278895 C53.1972355,445.278895 72.2991235,445.278895 76.9648577,445.278895 C77.3343563,442.208827 74.9631487,432.203427 61.5440994,428.465242 C60.1961217,429.503277 58.7407755,430.608837 54.0517927,432.203427 C40.1878378,427.234839 33.3274792,413.500363 33.4707171,391 Z",
      "id": "devyn_right_shoe_5",
      "fill": "#ED7BC8",
      "transform": "translate(48.235359, 418.139447) scale(-1, 1) translate(-48.235359, -418.139447) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.1091821,440.943197 C53.5221352,440.943197 24.6363938,440.943197 19.4047806,440.943197 C19.4423448,441.462688 19.4423448,442.907921 19.4047806,445.278895 C56.7991425,445.278895 75.9292695,445.278895 76.7951615,445.278895 C77.0937134,442.798305 76.7567659,434.284289 66.5881841,430.350919 C63.7909565,429.520181 57.4985188,434.775964 57.1091821,440.943197 Z",
      "id": "devyn_right_shoe_4",
      "fill": "#F1F1F1",
      "transform": "translate(48.132078, 437.771527) scale(-1, 1) translate(-48.132078, -437.771527) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.5986328,396.061035 C51.1016846,396.63269 50.4545898,402.528076 50.7543945,404.094116 C52.0751953,404.094116 64.0704346,404.094116 65.982666,404.094116 C68.0303955,404.094116 68.0222168,396.061035 65.982666,396.061035 C63.9431152,396.061035 52.607666,396.061035 51.5986328,396.061035 Z",
      "id": "devyn_right_shoe_3",
      "fill": "#F7A2DB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.6264648,408.966064 C49.1295166,409.53772 47.1503906,415.05603 47.4501953,416.62207 C48.7709961,416.62207 60.2243652,418.63208 62,419 C63.7756348,419.36792 65.9306641,411.432861 64,411 C62.0693359,410.567139 50.635498,408.966064 49.6264648,408.966064 Z",
      "id": "devyn_right_shoe_2",
      "fill": "#F7A2DB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44.9985352,422.076416 C44.1628418,422.136475 39.1323242,425.409912 38.1252441,427.02317 C39.8708496,426.73877 51.1689453,431.411865 52,432 C52.8310547,432.588135 58.8913574,426.932594 58,426 C57.1086426,425.067406 46.0075684,422.076416 44.9985352,422.076416 Z",
      "id": "devyn_right_shoe_1",
      "fill": "#F7A2DB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.5,306 L64.5,306 L64.5,306 C71.4035594,306 77,311.596441 77,318.5 L77,391 L52,391 L52,318.5 L52,318.5 C52,311.596441 57.5964406,306 64.5,306 Z",
      "id": "devyn_right_leg_bottom",
      "fill": "#353535"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "devyn_right_leg_top",
      "fill": "#353535",
      "x": "52",
      "y": "220",
      "width": "25",
      "height": "110",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.8632812,391 C81.5922852,391 85.6368001,391 86.9968262,391 C89.1517281,428.014677 97.9238281,424.814941 105.133545,428.836304 C104.450329,430.97193 101.650879,434.859375 97.9238281,434.859375 C82.8749055,430.089586 75.1880565,415.469795 74.8632812,391 Z",
      "id": "devyn_left_shoe_6",
      "fill": "#D764B1",
      "transform": "translate(89.998413, 412.929688) scale(-1, 1) translate(-89.998413, -412.929688) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.4707171,391 L60.4707171,391 L60.6591937,445.278895 C94.1972355,445.278895 113.299123,445.278895 117.964858,445.278895 C118.334356,442.208827 115.963149,432.203427 102.544099,428.465242 C101.196122,429.503277 99.7407755,430.608837 95.0517927,432.203427 C81.1878378,427.234839 74.3274792,413.500363 74.4707171,391 Z",
      "id": "devyn_left_shoe_5",
      "fill": "#ED7BC8",
      "transform": "translate(89.235359, 418.139447) scale(-1, 1) translate(-89.235359, -418.139447) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.1091821,440.943197 C94.5221352,440.943197 65.6363938,440.943197 60.4047806,440.943197 C60.4423448,441.462688 60.4423448,442.907921 60.4047806,445.278895 C97.7991425,445.278895 116.929269,445.278895 117.795162,445.278895 C118.093713,442.798305 117.756766,434.284289 107.588184,430.350919 C104.790957,429.520181 98.4985188,434.775964 98.1091821,440.943197 Z",
      "id": "devyn_left_shoe_4",
      "fill": "#F1F1F1",
      "transform": "translate(89.132078, 437.771527) scale(-1, 1) translate(-89.132078, -437.771527) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.5986328,396.061035 C92.1016846,396.63269 91.4545898,402.528076 91.7543945,404.094116 C93.0751953,404.094116 105.070435,404.094116 106.982666,404.094116 C109.030396,404.094116 109.022217,396.061035 106.982666,396.061035 C104.943115,396.061035 93.607666,396.061035 92.5986328,396.061035 Z",
      "id": "devyn_left_shoe_3",
      "fill": "#F7A2DB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M90.6264648,408.966064 C90.1295166,409.53772 88.1503906,415.05603 88.4501953,416.62207 C89.7709961,416.62207 101.224365,418.63208 103,419 C104.775635,419.36792 106.930664,411.432861 105,411 C103.069336,410.567139 91.635498,408.966064 90.6264648,408.966064 Z",
      "id": "devyn_left_shoe_2",
      "fill": "#F7A2DB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.9985352,422.076416 C85.1628418,422.136475 80.1323242,425.409912 79.1252441,427.02317 C80.8708496,426.73877 92.1689453,431.411865 93,432 C93.8310547,432.588135 99.8913574,426.932594 99,426 C98.1086426,425.067406 87.0075684,422.076416 85.9985352,422.076416 Z",
      "id": "devyn_left_shoe_1",
      "fill": "#F7A2DB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.5,306 L105.5,306 L105.5,306 C112.403559,306 118,311.596441 118,318.5 L118,391 L93,391 L93,318.5 L93,318.5 C93,311.596441 98.5964406,306 105.5,306 Z",
      "id": "devyn_left_leg_bottom",
      "fill": "#353535"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "devyn_left_leg_top",
      "fill": "#353535",
      "x": "93",
      "y": "220",
      "width": "25",
      "height": "110",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48,193 L115,193 L124.601562,262.458984 C108.813802,267.048828 93.9466146,269.34375 80,269.34375 C66.0533854,269.34375 51.9361979,267.048828 37.6484375,262.458984 L48,193 Z",
      "id": "devyn_hip",
      "fill": "#717171"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68,193 C69.3919088,193 72.7252421,193 78,193 C78,216.758762 78,230.092095 78,233 C68.611781,224.37257 68,215.301812 68,193 Z",
      "id": "devyn_zipper",
      "fill": "#696969"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.3859077,104.282431 C94.0624459,104.253183 93.0884775,107.49354 92.7297807,109.015652 C114.902724,116.900541 117.385834,147.890685 117.890337,192.886059 C108.654297,193.067854 52.9884701,194.61154 42.8814784,193.067854 C44.0343521,154.447019 45.5976611,120.931429 65.8164269,110.439 C65.2424963,107.256838 66.7093696,104.311679 80.3859077,104.282431 Z",
      "id": "devyn_shirt",
      "fill": "#4A4A4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.5256587,161.016591 C77.6616614,165.514419 76.4700097,169.138629 74.2995647,169.41921 C71.1127836,169.434459 72.0972235,165.116862 70.1781092,164.979748 C69.1166587,165.244397 68.6908376,169.437528 65.6611651,169.452194 C63.1324986,169.119039 63.6704043,165.348433 61.8790596,164.386814 C60.2284592,165.269332 60.2497483,168.115194 58.1771408,167.831674 C55.8068828,166.546932 56.0325548,162.951731 57.5201996,159.389415 C51.48421,153.32425 48.0769758,130.478323 69.444316,131.849209 C90.8116563,133.220096 87.685356,157.766461 76.5256587,161.016591 Z M73.7767617,158.379315 C75.8011055,158.523946 77.559824,156.921966 77.7049695,154.801192 C77.8501149,152.680417 76.3267236,150.843943 74.3023798,150.699311 C72.278036,150.55468 70.5193175,152.15666 70.3741721,154.277435 C70.2290266,156.398209 71.7524179,158.234683 73.7767617,158.379315 Z M61.0792708,155.542739 C63.1036146,155.687371 64.8623331,154.08539 65.0074786,151.964616 C65.152624,149.843842 63.6292328,148.007367 61.604889,147.862736 C59.5805452,147.718104 57.8218267,149.320085 57.6766812,151.440859 C57.5315358,153.561634 59.054927,155.398108 61.0792708,155.542739 Z",
      "id": "devyn_skull_graphic",
      "fill": "#F1F1F1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.4628906,216.636719 C79.5009766,213.052734 130.348633,209.03418 137.87793,216.636719 C145.407227,224.239258 159.791497,259.867202 143.924805,274.106445 C128.058112,288.345688 90.9487087,291.196583 74.5380859,275.958008 C58.1274632,260.719432 67.4248047,220.220703 73.4628906,216.636719 Z",
      "id": "devyn_bag_3",
      "fill": "#5B7046"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.4628906,216.636719 C79.5009766,213.052734 130.348633,209.03418 137.87793,216.636719 C145.407227,224.239258 173.539062,266.703125 126.664062,272.638672 C79.7890625,278.574219 84.1582031,225.794922 82.1123047,221.21582 C80.0664062,216.636719 75.2041016,216.636719 73.4628906,216.636719 Z",
      "id": "devyn_bag_2",
      "fill": "#778F5F"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "devyn_bag_1",
      "fill": "#495C36",
      "points": "50.0175781 130.613281 55.8886719 118.921875 80.0019531 231.203125 70.3154297 231.203125"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "devyn_left_arm_outer"
    }
  }, [_c('g', {
    attrs: {
      "id": "devyn_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "devyn_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "d": "M98.912738,246.928622 C98.8914512,249.818242 97.0252943,250.642142 95.0019589,254.051878 C92.6412267,258.030198 92.9203571,265.158495 90.304246,271.186368 C91.0608415,272.57097 95.5715878,269.95902 96.4891653,267.537106 C97.4067429,265.115193 98.1024372,263.147158 98.4209503,262.534448 C98.7394634,261.921738 99.5330056,261.963813 99.7757982,262.542337 C100.018591,263.120862 100.641407,284.156534 101.139984,285.187359 C101.638562,286.218184 104.397182,286.254824 104.872617,285.187359 C105.348052,284.119894 105.283497,267.476274 105.516342,267.03081 C105.749188,266.585346 106.35556,266.799751 106.611548,267.03081 C106.867536,267.261869 106.426002,285.04115 106.837897,285.702772 C107.249792,286.364393 110.098749,286.24974 110.406909,285.702772 C110.715069,285.155803 110.820834,267.433147 111.130617,267.03081 C111.440401,266.628472 112.068089,266.673527 112.324889,267.03081 C112.581689,267.388092 111.88092,284.454211 112.324889,285.187359 C112.768859,285.920507 115.531133,285.932078 115.785294,285.187359 C116.039454,284.44264 116.603399,267.280101 116.870958,267.03081 C117.138517,266.781518 117.498443,266.804835 117.753416,267.03081 C118.008389,267.256785 118.278181,280.075307 118.718903,280.771991 C119.159624,281.468674 121.250158,281.633291 121.558318,280.771991 C121.866478,279.910691 120.392938,248.662752 120.433968,246.928622 C120.570704,241.14952 116.954895,235.113225 109.700412,235.113225 C102.445929,235.113225 98.9584496,240.723404 98.912738,246.928622 Z",
      "id": "devyn_left_hand",
      "fill": "#DBBFAF"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "devyn_left_arm_bottom",
      "fill": "#DBBFAF",
      "x": "98.912738",
      "y": "192.049486",
      "width": "21.52123",
      "height": "64.5636901",
      "rx": "10.760615"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "devyn_left_arm_top",
      "fill": "#DBBFAF",
      "x": "98.912738",
      "y": "116.72518",
      "width": "21.52123",
      "height": "96.8455352",
      "rx": "10.760615"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M109.135322,116.72518 L109.135322,116.72518 L109.135322,116.72518 C116.563977,116.72518 122.586091,122.747295 122.586091,130.175949 L122.586091,143.626718 L95.6845535,143.626718 L95.6845535,130.175949 L95.6845535,130.175949 C95.6845535,122.747295 101.706668,116.72518 109.135322,116.72518 Z",
      "id": "devyn_left_shoulder",
      "fill": "#4A4A4A"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.239385,98.4321349 C72.0564605,103.692337 72.4985919,107.375461 70.1633235,110.268811 C72.0294757,113.732152 86.6961585,113.968258 88.456369,110.268811 C86.3415509,107.304777 86.124737,104.309517 87.3803075,98.4321349 C85.8200709,94.1914648 73.4180506,94.3334511 71.239385,98.4321349 Z",
      "id": "devyn_neck",
      "fill": "#D4B5A7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.197862,8.07344315 C107.907967,8.46698322 124.568531,20.6945727 126.431672,42.7911384 C128.294814,64.887704 118.30394,76.8005665 115.314822,79.4612967 C123.859213,79.4612967 127.075313,86.6842545 122.890337,96.2800119 C129.429723,94.8813421 130.749579,100.900036 129.346706,104.888504 C134.44171,104.148712 138.067638,102.854601 140.38054,97.6066991 C144.141501,99.6558396 142.10497,108.778718 139.03126,111.344873 C135.957549,113.911027 130.989171,113.290506 129.429723,112.364189 C129.346706,113.859011 132.368926,114.616142 134.727014,114.573057 C133.52958,116.141438 124.441904,117.556396 125.04246,109.19275 C118.822005,112.364189 112.668804,106.306089 115.357907,100.584258 C107.56224,101.074475 102.509795,95.428305 102.445169,91.9757659 C99.988827,94.094262 92.363397,100.34992 82,100.584258 C71.636603,100.818596 62.7055027,94.0679909 60.47877,91.9757659 C59.8887226,97.6066991 54.0896548,99.6090772 50.7942164,98.4321349 C52.5727654,104.051509 48.0835713,107.110508 43.2617859,105.964565 C43.3999716,111.437872 34.5319217,115.201461 30.3490479,115.649119 C31.6941248,114.573057 34.0926701,111.344873 34.6532939,109.19275 C26.5423753,114.573057 17.4357845,106.035497 23.8926789,95.2039504 C25.8556505,100.620512 34.1699069,103.268632 37.8814784,102.736381 C34.1693815,96.9819739 38.9880143,91.1818553 43.2617859,91.9757659 C40.2884304,88.8500384 36.7938577,77.1704627 49.7181549,73.6827204 C47.9811143,72.5830149 32.9940155,70.1329784 46.6160714,33.4638709 C53.7102347,14.3671473 68.487757,7.67990308 88.197862,8.07344315 Z",
      "id": "devyn_pigtails",
      "fill": "#0D8A86"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.433968,61.8460438 C118.55982,60.5965935 121.611696,59.0093415 125.071884,61.8460438 C128.031578,64.2724364 125.806787,73.791436 121.814276,79.0630279 C117.859603,84.2846583 111.426584,85.3687697 108.901538,83.3672739 C103.574298,95.3673562 89.9974278,101.739658 80.9239385,101.660319 C56.6322991,101.447914 46.4899704,76.8761716 46.4899704,56.4657363 C46.4899704,24.271957 59.3657664,13.4237031 80.9239385,13.4237031 C100.273712,13.3184946 121.751225,23.5376239 116.433968,61.8460438 Z",
      "id": "devyn_face",
      "fill": "#DBBFAF",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114.281845,69.6500124 C116.207512,65.6118919 119.218172,61.8687952 122.890337,63.1936434 C126.562502,64.5184916 121.860513,79.3570276 112.129722,79.3345659 C113.255961,78.6395657 116.334401,75.4055717 116.433968,72.8781969 C116.533535,70.3508221 115.716638,69.0846598 114.281845,69.6500124 Z",
      "id": "devyn_ear",
      "fill": "#D4B5A7"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "devyn_left_cheek",
      "fill": "#DBB7A6",
      "cx": "97.064861",
      "cy": "80.1390894",
      "r": "6.45636901"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "devyn_right_cheek",
      "fill": "#DBB7A6",
      "cx": "60.47877",
      "cy": "80.1390894",
      "r": "6.45636901"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.9748318,89.1638379 C68.9975474,90.1415555 70.0725603,95.2256872 74.0794264,95.2256872 C78.0862926,95.2256872 82.4840725,90.2393273 82.1908872,89.7504685 C81.8977018,89.2616097 77.7931072,92.1947625 74.0794264,92.1947625 C70.0725603,92.0969908 69.9748318,89.1638379 69.9748318,89.1638379 Z",
      "id": "devyn_mouth_open_bottom",
      "fill": "#C9A89D",
      "fill-rule": "nonzero",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.0846228,89.7415713 C70.7672119,90.162405 80.2317752,90.2676134 83.3866297,89.6363629 C85.0692187,89.3207376 81.2833934,92.4769904 74.9736845,92.4769904 C68.6639756,92.4769904 69.0846228,89.7415713 69.0846228,89.7415713 Z",
      "id": "devyn_mouth_bottom",
      "fill": "#C9A89D",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.0330047,89.6363629 C68.0330047,88.2686533 69.0846228,87.1113606 74.5530372,87.1113606 C78.3388625,87.1113606 84.4382478,89.0051123 87.4879404,88.1634448 C88.1189113,87.953028 88.1189113,88.4790701 87.2776168,88.7946954 C83.3866297,90.162405 79.6008043,90.162405 73.8169045,90.162405 C70.0310792,90.0571966 68.0330047,89.6363629 68.0330047,89.6363629 Z",
      "id": "devyn_mouth_top",
      "fill": "#BD9B90",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.3714038,62.9115969 C72.3714038,60.8340837 77.7172962,60.6520254 77.7199233,62.9115969 C77.7225504,65.1711685 79.4390997,76.961608 77.7225504,79.0567228 C76.0060012,81.1518377 70.9599925,80.4498757 70.1790861,79.0567228 C69.3981797,77.66357 69.5454288,75.391651 71.239385,74.7587819 C72.9333412,74.1259127 72.3714038,64.9891102 72.3714038,62.9115969 Z",
      "id": "devyn_nose",
      "fill": "#C9A89D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.304246,66.3159304 C89.1194499,58.5502213 101.639699,57.3650443 103.52123,64.0897996 C103.530162,73.1703642 88.3507595,73.972395 86.304246,66.3159304 Z",
      "id": "devyn_left_eye_whites",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "devyn_left_pupil",
      "fill": "#383838",
      "cx": "97.064861",
      "cy": "66.1502898",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.304246,66.3159304 C89.1194499,58.5502213 101.639699,57.3650443 103.52123,64.0897996 C103.530162,73.1703642 88.3507595,73.972395 86.304246,66.3159304 Z",
      "id": "devyn_left_eye_lids",
      "fill": "#D4B5A7",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.0872659,66.3159304 C66.272062,58.5502213 53.7518133,57.3650443 51.8702819,64.0897996 C51.8613497,73.1703642 67.0407525,73.972395 69.0872659,66.3159304 Z",
      "id": "devyn_right_eye_whites",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "devyn_right_pupil",
      "fill": "#383838",
      "cx": "62.630893",
      "cy": "66.1502898",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.0872659,66.3159304 C66.272062,58.5502213 53.7518133,57.3650443 51.8702819,64.0897996 C51.8613497,73.1703642 67.0407525,73.972395 69.0872659,66.3159304 Z",
      "id": "devyn_right_eye_lids",
      "fill": "#D4B5A7",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.3241444,55.2651509 C88.4788319,54.097622 99.8185121,53.8991224 102.30483,55.2651509 C104.791148,56.6311794 102.970692,57.9770753 101.239451,57.4459303 C99.50821,56.9147854 89.2284467,56.806118 87.3895234,57.4459303 C85.5506001,58.0857427 84.1694569,56.4326798 86.3241444,55.2651509 Z",
      "id": "devyn_left_brow",
      "fill": "#4A4A4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.9913021,55.2651509 C65.8366146,54.097622 54.4969344,53.8991224 52.0106165,55.2651509 C49.5242985,56.6311794 51.3447546,57.9770753 53.0759955,57.4459303 C54.8072364,56.9147854 65.0869998,56.806118 66.9259231,57.4459303 C68.7648464,58.0857427 70.1459896,56.4326798 67.9913021,55.2651509 Z",
      "id": "devyn_right_brow",
      "fill": "#4A4A4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.6074104,29.7780467 C42.0774878,39.9286466 41.8189808,47.9439387 38.221951,55.948197 C38.9660723,55.948197 44.4571179,51.6757389 45.8347709,49.4061844 C45.8347709,51.1976061 44.6273542,59.3458297 44.4571179,62.5272517 C49.4974783,58.6633082 53.3314728,52.2957353 56.4146412,43.3661026 C55.0404035,50.1383581 55.4016302,57.0366059 57.8942258,58.3596151 C57.8942258,56.2216784 58.5704421,52.592598 59.0751087,50.5074661 C58.9839482,53.9024717 60.1748141,56.5952525 61.3903748,57.1259274 C61.0740716,53.0901713 60.655574,47.9439387 61.7192881,42.9114597 C62.93012,48.788027 65.9168737,55.948197 70.7013542,58.3596151 C70.7013542,57.1259274 70.7013542,55.948197 70.7013542,54.2639611 C71.616637,55.3352938 72.9782646,57.4351374 75.0534135,58.3596151 C74.4092478,55.3352938 73.0166203,47.9439387 72.9782646,43.9031912 C74.1775373,47.5075769 76.5440319,54.2639611 80.4169076,57.4351374 C85.5944027,57.8683468 85.203227,56.5429732 88.1726419,56.5429732 C84.9541776,52.592598 82.794436,47.9439387 82.970452,45.771587 C83.5069064,48.4840712 91.4981703,57.4351374 94.7136036,57.4351374 C95.4893872,54.8069833 94.7136036,51.1976061 94.1117342,49.0622966 C95.6861572,50.835854 97.995381,54.8069833 98.554954,55.948197 C99.0879933,54.8069833 99.1113745,53.0631122 99.0879933,51.1976061 C100.107835,52.592598 101.362539,55.948197 101.362539,57.4351374 C103.162105,54.8069833 102.285178,50.5074661 101.362539,47.9439387 C103.079877,49.9765285 107.504181,59.0841702 108.474633,61.2667676 C108.999003,60.4119082 110.470585,58.3815561 110.411334,54.8069833 C111.841266,56.8545476 116.84637,60.3986451 119.711542,61.2667676 C118.481007,58.5590122 117.842358,54.4102907 117.673173,52.6837585 C119.100478,54.953313 123.701178,55.6755722 124.55487,55.948197 C121.715234,52.6296401 118.260874,47.9439387 118.260874,41.1615661 C118.260874,34.3791934 110.411334,12.3766383 84.7763227,12.6351453 C59.1413117,12.8936522 53.137333,19.6274468 47.6074104,29.7780467 Z",
      "id": "devyn_bangs",
      "fill": "#0F9C98"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.7136036,60.4351374 C95.4893872,57.8069833 94.7136036,54.1976061 94.1117342,52.0622966 C95.6861572,53.835854 97.995381,57.8069833 98.554954,58.948197 C99.0879933,57.8069833 99.1113745,56.0631122 99.0879933,54.1976061 C100.107835,55.592598 101.362539,58.948197 101.362539,60.4351374 C103.162105,57.8069833 102.285178,53.5074661 101.362539,50.9439387 C103.079877,52.9765285 107.504181,62.0841702 108.474633,64.2667676 C108.999003,63.4119082 110.470585,61.3815561 110.411334,57.8069833 C111.841266,59.8545476 116.84637,63.3986451 119.711542,64.2667676 C118.269505,60.9892498 116.702836,54.6813207 112.888184,46.9150391 C114.967285,48.0463867 119.134277,50.1235352 122.352051,50.1235352 C117.805176,46.548654 112.296704,40.6563215 110.411334,37.5341797 C105.154297,28.8286133 100.1875,17.8466797 77.7644043,12.9663086 C81.0798662,20.7357289 86.2871094,32.1162109 101.362539,43.1738281 C83.2138672,35.6738281 77.6804199,18.9672852 76.3515625,14.1240234 C75.6640625,31.3967285 87.9208984,54.1976061 94.7136036,60.4351374 Z",
      "id": "devyn_bangs",
      "fill": "#ED7BC8"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42611164","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_5/svg/characters/devyn.vue
// module id = 802
// module chunks = 1